import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { BranchACQ133NewSteps } from './branches/BranchACQ133NewSteps';
import { BranchBIAB004, BranchBusinessBox } from './branches/BranchBIAB004';
import { BranchCampaignAssistant } from './branches/BranchCampaignAssistant';
import { BranchCmsBusinessMaturity } from './branches/BranchCmsBusinessMaturity';
import { BranchFreeCRMTour } from './branches/BranchFreeCRMTour';
import { BranchOptionalPhoneNumber } from './branches/BranchOptionalPhoneNumber';
import { BranchQuestionFallback } from './branches/BranchQuestionFallback';
import { ProductSetupUIBranch } from './branches/ProductSetupUIBranch';
const DefaultBranches = [BranchQuestionFallback];
const softwareSignupBranches = [...DefaultBranches, BranchOptionalPhoneNumber, BranchACQ133NewSteps];
export const FlowBranches = {
  [Flow.Crm]: [...softwareSignupBranches, BranchBIAB004, BranchBusinessBox, BranchFreeCRMTour],
  [Flow.Marketing]: [...softwareSignupBranches, BranchCampaignAssistant],
  [Flow.Sales]: [...softwareSignupBranches, ProductSetupUIBranch],
  [Flow.Service]: softwareSignupBranches,
  [Flow.CmsFree]: [BranchCmsBusinessMaturity, ...softwareSignupBranches]
};
export const getFlowBranches = () => {
  return FlowBranches[getFlowKey()] || DefaultBranches;
};